module.exports = __webpack_public_path__ + "img/customer-representative.75dc652a.svg";